import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AssetDistributionOption, ButtonBar, ScreenHeader
} from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOABusinessOperations() {
  const { powerOfAttorney, setPowerOfAttorney } = useContext(NewPOAContext);
  const navigate = useNavigate();
  const [ businessOperations, setBusinessOperations ] = useState(powerOfAttorney.operating_business || false);
  
  useScrollToTop();
  
  const handleBack = useCallback(() => {
    navigate('../digital-assets');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    setPowerOfAttorney(prev => ({ 
      ...prev, 
      operating_business: businessOperations
    }));
    navigate('../estate-trust');
  }, [ businessOperations, setPowerOfAttorney, navigate ]);
  
  return (
    <div className="new-poa-business-operations screen-container screen">
      <ScreenHeader
        title="Business Operations"
        description="Decide whether to grant your agent power to operate your business"
        handleBack={handleBack}
      />
      
      <div className="content-section">
        <h3>What Are Business Operation Powers?</h3>
        <p>
          Business operation powers allow your agent to manage and operate any businesses 
          you own or have an interest in. This includes:
        </p>
        <ul className="business-list">
          <li>Managing day-to-day business operations</li>
          <li>Making business decisions and transactions</li>
          <li>Hiring and firing employees</li>
          <li>Entering into contracts on behalf of the business</li>
          <li>Managing business finances and accounts</li>
          <li>Filing business tax returns and documents</li>
          <li>Buying, selling, or dissolving business interests</li>
        </ul>

        <h3>What Your Agent Can Do</h3>
        <p>If you grant this power, your agent can:</p>
        <ul className="agent-powers">
          <li>Make all business decisions as if they were you</li>
          <li>Access business bank accounts and financial records</li>
          <li>Sign contracts and agreements</li>
          <li>Manage business employees and operations</li>
          <li>Handle business tax matters</li>
          <li>Sell or transfer business ownership</li>
        </ul>

        <h3>Do You Want to Grant This Power?</h3>
        <div className="asset-distribution-option-container">
          <AssetDistributionOption
            id="business-operations-yes"
            label="Yes"
            description="Grant power to operate my business"
            value="yes"
          />
          <AssetDistributionOption
            id="business-operations-no"
            label="No"
            description="Do not grant power to operate my business"
            value="no"
          />
        </div>

        <div className="important-note">
          <h4>Important:</h4>
          <p>
            Business operation powers are very broad and give your agent significant control 
            over your business affairs. Make sure you trust your agent completely before 
            granting these powers.
          </p>
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
